import { arrayBufferToBase64, base64ToUint8Array, stringToBase64 } from './base64';

export async function withRsaEncryption(
  callback: (publicKey: string) => Promise<Uint8Array>,
  { modulusLength = 4096, label }: { modulusLength?: number; label?: string } = {},
): Promise<string> {
  const pair = await crypto.subtle.generateKey(
    {
      name: 'RSA-OAEP',
      modulusLength,
      publicExponent: new Uint8Array([1, 0, 1]),
      hash: 'SHA-256',
    },
    true,
    ['encrypt', 'decrypt'],
  );
  const publicKeyBuffer = await crypto.subtle.exportKey('spki', pair.publicKey);
  const publicKeyBase64 = arrayBufferToBase64(publicKeyBuffer);

  const pemPublicKey = `-----BEGIN PUBLIC KEY-----\n${publicKeyBase64}\n-----END PUBLIC KEY-----`;

  const encrypted = await callback(pemPublicKey);
  const decrypted = await crypto.subtle.decrypt(
    { name: 'RSA-OAEP', label: label ? new TextEncoder().encode(label) : undefined },
    pair.privateKey,
    encrypted as BufferSource,
  );

  const decoder = new TextDecoder('utf-8');
  return decoder.decode(decrypted);
}

export function withWallesterEncryption(label: string, callback: (key: string) => Promise<string>) {
  return withRsaEncryption(
    async (key) => {
      const res = await callback(stringToBase64(key));
      const pemBody = res.split('\n').slice(1, -2).join('');
      const decoded = base64ToUint8Array(pemBody);
      return decoded;
    },
    { label },
  );
}
